/**
 * Test IDs for QA automation.
 */
export const testIds = {
  assetLinkOpen: "asset-link-open",
} as const;
